import { Box, TableCell, TableRow, Typography, useTheme } from "@mui/material";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import { useTranslation } from "react-i18next";
import { tokens } from "../theme";

const NoDataTable = ({ cols }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <TableRow>
      <TableCell colSpan={cols} align="center" sx={{ border: "none" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            py: 3,
          }}
        >
          <InboxOutlinedIcon sx={{ fontSize: 32, color: colors.grey[300] }} />
          <Typography
            variant="body2"
            sx={{ color: colors.grey[300], fontWeight: 600 }}
          >
            {t("common.noData")}
          </Typography>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default NoDataTable;
